export const filterMenuItems = ({ menuItems, isLoggedIn, formFactor }) => {
    if (!menuItems || !menuItems.length) {
        return menuItems;
    }

    return menuItems
        .filter((menuItem) => isLoggedIn ? menuItem.permissions?.user : menuItem.permissions?.guest)
        .filter((menuItem) => menuItem.device?.[formFactor]);
};
